import React from 'react';
import { Kid, Quest } from '../types';

interface TodayCardProps {
  kid: Kid | undefined;
  quests: Quest[];
  todayDateStr: string;
}

export const TodayCard: React.FC<TodayCardProps> = ({ kid, quests, todayDateStr }) => {
  // Only count active quests
  const activeQuests = quests.filter((q) => q.is_active === 1);
  const totalCount = activeQuests.length;
  const completedCount = activeQuests.filter((q) => q.is_completed_today).length;
  const isAllDone = totalCount > 0 && completedCount === totalCount;
  const progressPercent = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  const streak = kid?.current_streak ?? 0;
  const stars = kid?.personal_stars_available ?? 0;

  return (
    <div className="today-status-card">
      <div className="today-card-header">
        <div>
          <h2 className="today-card-title">
            {isAllDone ? 'All Done! 🎉' : "Today's Quests"}
          </h2>
          <p className="today-card-date">{todayDateStr}</p>
        </div>

        <div className="today-card-badges">
          <div className="badge-streak" title={`${streak} day streak`}>
            <span>🔥</span>
            <span>{streak}</span>
          </div>
          <div className="badge-points" title={`${stars} available stars`}>
            <span>⭐</span>
            <span>{stars}</span>
          </div>
        </div>
      </div>

      <div className="progress-bar-container">
        <div className="progress-track" role="progressbar" aria-valuenow={progressPercent} aria-valuemin={0} aria-valuemax={100}>
          <div
            className="progress-fill"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
        <span className="progress-fraction">
          {completedCount}/{totalCount}
        </span>
      </div>
    </div>
  );
};
